import ApiAuthService from "./apis/ApiAuthService";
import ApiLibraryService from "./apis/ApiLibraryService";
import ApiCommonService from "./apis/ApiCommonService";
import ApiStudentActivityService from "./apis/ApiStudentActivityService";
import ApiClassService from "./apis/ApiClassService";
import ApiCompanyService from "./apis/ApiCompanyService";
import ApiAdminService from "./apis/ApiAdminService";
import ApiClassTopicService from "./apis/ApiClassTopicService";
import ApiTopicExamService from "./apis/ApiTopicExamService";
import ApiCmsService from "./apis/ApiCmsService";
import ApiStudentService from "./apis/ApiStudentService";
import ApiReportService from "./apis/ApiReportService";
import ApiClassPromotionService from "./apis/ApiClassPromotionService";
import ApiCalendarViewService from "./apis/ApiCalendarViewService";

export default class ApiService {
    constructor() {
        this.apiAuthService = new ApiAuthService();
        this.apiLibraryService = new ApiLibraryService();
        this.apiCommonService = new ApiCommonService();
        this.apiStudentActivityService = new ApiStudentActivityService();
        this.apiClassService = new ApiClassService();
        this.apiCompanyService = new ApiCompanyService();
        this.apiAdminService = new ApiAdminService();
        this.apiClassTopicService = new ApiClassTopicService();
        this.apiTopicExamService = new ApiTopicExamService();
        this.apiCmsService = new ApiCmsService();
        this.apiStudentService = new ApiStudentService();
        this.apiReportService = new ApiReportService();
        this.apiClassPromotionService = new ApiClassPromotionService();
        this.apiCalendarViewService = new ApiCalendarViewService(); // Corrected capitalization
    }
}
